export default {
    // ash国际化
    ash: {
        noData: 'No permission',
        imported: 'Imported',
        payCancelEmptyTip: 'The handling fee deduction rate cannot be empty.',
        minCancelEmptyTip: 'The lower limit of the period from the time when the booking is canceled to the check-in time cannot be empty. ',
        maxCancelEmptyTip: 'The upper limit of the period from the time when the reservation is canceled to the time when the check-in date is reached cannot be ',
        lockTypeEmpty: 'The lock type cannot be empty',
        lockDateEmpty: 'The lock date cannot be empty',
        effectiveDateEmpty: 'The effective date cannot be empty',
        maxCustomerNumberTip: 'The maximum number of shared customers must be an integer. ',
        minCancelIntegerTip: 'The minimum number of days for canceling the reservation to check-in must be an integer. ',
        maxCancelIntegerTip: 'The maximum number of days from the time when the reservation is canceled to the time when the check-in date is reached must be an integer. ',
        payCancelIntegerTip: 'The handling fee deduction rate must be an integer.',
        numCancelIntegerTip: 'The cancellation quantity must be an integer. ',
        canNotAccepttip: 'Cannot handle the order because it does not belong to the vehicle group. ',
        acceptSuccessTip: 'Handling succeeded. ',
        canNotNoticetip: 'Cannot publish the notification because the order contains orders that are not in the queue. ',
        leastOneDataTip: 'Select at least one order record. ',
        noticeSuccessTip: 'Notification released successfully. ',
        hasCars: 'A car. ',
        noCar: 'Carless',
        noshowTip: 'According to the cancellation rule, the Noshow fee {0}{1} will be deducted for this operation. Are you sure you want to continue? ',
        shuttles: 'Shuttles ',
        rentingCar: 'Dedicated Vehicle ',
        companyVehicleOrder: 'Corporate Vehicle Order ',
        travelVehicle: 'Dedicated Vehicle',
        keywordPlaceholder: 'Order No./Group No./Departure Location',
        selectAll: 'Select All',
        accept: 'Handling',
        userDate: 'Date of Use',
        dosages: 'Dosages',
        duration: 'Daily Time Required',
        vehicleAddress: 'Vehicle Use Location',
        importDeadlineDate: 'List Import Deadline',
        importDeadlineDateTip: 'Select the end time for importing the name list.',
        cancelQty: 'Canceled Qty.',
        cancelQtyTip: 'Canceled quantity. Value range: 0 to 100',
        orderList: 'Order List',
        orderStatistics: 'Order Statistics',
        expenseDept: 'Expense Allocation Dept',
        expenseItem: 'Expense to Project',
        contactPhone: 'Mobile NO.',
        contactEmail: 'Email',
        localPhone: 'Local Number',
        cancelRuleDesc: 'Cancellation Rule Description',
        carNumEveryDay: 'Number of Vehicles Used Per Day',
        carStartTime: 'Vehicle Start Time',
        carEndTime: 'Vehicle End Time',
        carTimeEveryDay: 'CarTimeEveryDay',
        carStartAddress: 'Vehicle Start Location',
        modifyLogs: 'Modify Logs',
        modifyBy: 'Modified By',
        modifyDate: 'Change Date',
        modifyInfoBefore: 'Information Before Modification',
        modifyInfoAfter: 'Modified Information',
        allotsRoomTypeTip: 'The rooms from {0} to {1} will be automatically allocated to {2}.',
        allots: 'Allots',
        queuingQuantity: 'Queuing Quantity',
        exportBNOrder: 'Export BN Order',
        queTimeOutTip: 'The deadline of the queue reservation is over. You cannot make a reservation again.',
        vehiclesPhoneTips: 'This phone number is used to receive message notifications.',
        vehiclesPhonePlaceholder: 'Enter the Phone Number',
        plsOrderStatus: 'Please Select an Order Status',
        bookPerson: 'Reserved By',
        plsGroupNO: 'Please Enter the Group ID',
        roomsLeft: '{0} Rooms',
        cancelFinesTips: 'Canceling the order in the current time segment will charge {0}{1}. Are you sure you want to cancel the order?',
        exportOrder: 'Export Order',
        allExhi: 'All', // done
        recentExhi: 'Upcoming Events', // done
        pastExhi: 'Previous Events', // done
        searchExhi: 'Enter Events City or County Name', // done
        expand: 'Expand',
        contraction: 'Contraction',
        noPermission: 'You do not have access to the action!',
        noPerTips: 'I\'m sorry! You do not have access to the resource for the time being, so make sure you sign in or return to the home page to select another',
        searchHotel: 'Search', // done
        priceTip: 'Price range start price cannot be greater than the end price',
        queuing: 'Queuing',
        roomLackTip: '{0} room type, in {1} days only left {2} margin, please re-enter',
        delRoomTip: 'This action will delete the room type of {0}, do you want to continue?',
        delHotelTip: 'This action will delete the "{0}" hotel, do you want to continue?',
        viewBigMap: 'View the Big Map',
        followSroll: 'Follow the Float',
        food: 'Food',
        phoneNumber: 'PhoneNumber',
        address: 'Address',
        traffic: 'Traffic',
        attractions: 'Attractions',
        shopping: 'Shopping',
        entertainment: 'Entertainment',
        carrental: 'Car Rental',
        clear: 'Clear',
        addCustom: 'Add Customization',
        getDistance: 'Distance Calculation',
        helpTip1: 'The first step, select Alipay Payment, click next, the browser address bar will display the intercept prompt icon, as shown in the red circle below',
        helpTip2: 'The second step, as shown in the red circle and numbers below',
        helpTip3: 'First, click on the icon of the block prompt to display a small dialog box',
        helpTip4: 'Second, select Always allow itravel to be displayed',
        helpTip5: 'Finally, click To complete the submission',
        helpTip6: 'In the third step, click the browser refresh button to refresh the page and the cash register prompt window disappears. After selecting Alipay, click the Next button',
        helpTip7: 'The fourth step is to complete the payment in a new page that opens.',
        personalPayTip: 'Prepaid Tips: After check-in, if the order is modified or cancelled. Service charge is non-refundable',
        payCost: 'Amount Paid',
        plsPayWay: 'Please Choose a Payment Method',
        browserTip: 'Tip: Some browsers block Alipay pop-ups, click to see how to set up unblocked browsers.',
        nextStep: 'Next',
        cashRegister: 'Payment', // done
        dontClose: 'Please complete the payment on the newly opened page and do not close this window payment until the payment is complete',
        doneNext: 'When you\'re done, click the button below based on your payment',
        donePay: 'Complete Payment',
        hasProblem: 'Encounter a Problem', // done
        wechat: 'Wechat',
        wechatPay: 'Wechat',
        alipay: 'Alipay',
        ashHotel: 'EVENTSGO Hotel',
        paySuccess: 'Payment was Made Successfully',
        totalCost: 'The total amount of your hotel purchase disonion is',
        ssfw: 'Facilities',
        cyyl: 'Dining and Entertainment',
        mfss: 'Free Facilities',
        kfss: 'Room Facilities',
        jdfwss: 'Hotel Services',
        hyss: 'Conference Facilities',
        fygkbm: 'Expenses go to the Department',
        fygkbmbm: 'Expenses to the Department Code',
        allOrder: 'All Orders',
        freeRow: 'Free Travel',
        comments: 'Comments',
        specialFares: 'Special Fares',
        start: 'Start',
        to: 'To',
        dateRangeTip: 'Please select a check-in date range',
        noOrderTip: 'No order information found',
        cars: 'Vehicle',
        booking: 'Booking',
        callNo: 'Call',
        bussinessPlaceholder: 'Please enter the order number/group number/hotel name/project manager to inquire',
        sendNotify: 'Send a Notification',
        exportFullOrder: 'Export Full Order',
        atLeastOne: 'Please select at least one order that requires a notification!',
        postNotify: 'Post a Notification',
        queues: 'Queues',
        hasRoom: 'Have Room.',
        noRoom: 'No Room',
        sendTips: 'You are sure to send notifications for selected orders, do you want to continue?',
        sendSuccess: 'The Notification was Sent Successfully!',
        noReturnData: 'Interface does not return data',
        cancelTip: 'This action goes to cancel the order number {0}, do you want to continue?',
        successTip: 'Congratulations, the order number {0} cancelled successfully!',
        inTheQueue: 'In the Queue',
        queueFailed: 'Queue Failed',
        importPlaceholder: 'Enter the hotel name and customer name',
        cancelList: 'Cancel the List',
        import: 'Import',
        aaa: 'Import Template',
        importBtn: 'Import',
        importTips: 'The current order has been imported {0} customer information, there are still {1} not imported',
        fristName: 'LastName',
        lastName: 'FristName',
        checkinTine: 'Check-in Time',
        checkoutTime: 'Check-out Time',
        resident: 'A Resident',
        represent: 'Representative Office',
        representEmptyTip: 'Representative Office cannot be empty.',
        groupLevel: 'Group Level',
        customerUnits: 'Customer Units',
        industry: 'Industry',
        escorts: 'Escorts',
        escortsTel: 'Escort Phone',
        copyman: 'Copyman',
        confirmTips: 'Confirm whether you want to unselect the list?',
        undoSuccess: 'Undo Success',
        undoFailure: 'Undo Failure',
        undoTips: 'Please select at least one revocation list',
        updateTip: 'Upload images no longer than {0}MB!',
        updateSizesTip: 'The size of the uploaded image should be between {0}-{1}kB!',
        imgFormatTip: 'The uploaded image format should be {0}!',
        roomUseInfo: 'Room Usage',
        payWay1: 'Personal Online Payments',
        payWay2: 'Personal IVR Payment (OP)',
        payWay3: 'External Moon Junction',
        payWay4: 'Hotel-to-shop Payment',
        cancelOrderTips: 'Your request for cancellation of your order has been accepted and will be processed by customer service later!',
        hotelCollections: 'Hotel Collections',
        emailTips: 'This mailbox is used for receiving the booking information, please carefully check the correct maintenance!', // done
        emailCheck: 'Please enter a number with a length of 3-4 at the beginning of 0',
        telCheck: 'Please enter 7 to 8 digits',
        extensionCheck: 'Please enter 1 to 6 digits',
        editContacts: 'Edit Contacts',
        addContacts: 'Add Contact', // done
        editInvoices: 'Edit Common Invoices',
        addInvoices: 'Add Common Invoices', // done
        invoicesCategory: 'Invoice Type', // done
        invoicesHeaderUp: 'Invoice Header', // done
        taxpayerIdentificationNum: 'TIN', // done
        numberBit: '15/18/20 Bit',
        registeredAddress: 'Registered Address',
        bank: 'Opening Bank', // done
        account: 'Opening Bank Account No.', // done
        plsRightBankNo: 'Please enter the correct bank account number',
        modify: 'Modify',
        delAddressTip: 'Are you sure you\'re deleting the common address used by {0}?',
        delContactTip: 'Are you sure you\'re deleting a contact( {0}?)',
        delInvoiceTip: 'Are you sure you\'re deleting the common invoice for {0}?',
        modifyNameTip: 'Please fill in the information on the documents you use strictly.',
        modifySuccess: 'The Modification was Successful',
        hotelNameCn: 'Hotel Name (Chinese)',
        hotelNameEn: 'Hotel Name (US)',
        isCanBook: 'Can be Booked',
        hotelFaxPlace: 'Area code, Telephone, Fax',
        maxLengthTip: 'Enter up to 1333 Chinese characters or 4000 English letters and numbers',
        plsTelName: 'Please enter your landline or mobile phone number',
        plsTelNumber: 'Please enter the 6-8-bit landline number',
        plsPhoneNo: 'Please enter your 11-digit mobile phone number',
        timeFormat: 'Time Format 02:00-14:00',
        timeFormat24: 'Time is 24-hour',
        plsRightTel: 'Please enter the correct phone number',
        plsHotelCn: 'Please enter the name of the hotel (Chinese)',
        plsHotelEn: 'Please enter the name of the hotel',
        plsChoseBisness: 'Please choose a business type',
        plsChoseBrand: 'Please select the hotel brand',
        plsChoseStars: 'Please select the hotel star',
        plsChoseLevel: 'Please select the customer level',
        plsChoseBooking: 'Please choose whether you can book',
        plsChoseRecom: 'Please choose whether to recommend',
        plsHotelIntroductionCn: 'Please enter the hotel profile (Chinese)',
        plsHotelIntroductionEn: 'Please enter the hotel profile',
        plshotelResponsible: 'Please enter the person responsible for the hotel',
        maxFivePerson: 'Add up to 5 responsible persons',
        rspHotel: 'Library Hotel',
        travelHotel: 'Travel Hotels',
        hotHotelMax: 'Popular hotels have exceeded the number of configurations',
        travelHotelRepeat: 'Travel Library Hotel Repeat Mapping',
        hotelRepeatTip: 'Hotel already exists, please choose again!',
        addPlus: 'Add',
        onlyNumbers: 'Only numbers can be entered',
        plsHotelAdressCn: 'Please enter the hotel address (Chinese)',
        plsHotelAdressEn: 'Please enter the hotel address',
        enableTime: 'NOSHOW Enable Point in Time',
        arrivalDateOfBusinessTripCustomers: 'Arrival date of business trip customers',
        businessTripCustomerDepartureDate: 'Business trip customer departure date',
        pleaseSelectTheArrivalDate: 'Please select the arrival date',
        pleaseSelectTheDepartureDate: 'Please select the departure date',
        plsSelectDate: 'Please choose the start date',
        queueDeadline: 'Queue Deadline',
        selectDeadline: 'Please select the queue dying due date',
        selectStartDate: 'Please select NOSHOW enabled date',
        selectStartTime: 'Please select NOSHOW enabled time',
        editHotelRules: 'Please fill in the hotel rules',
        editHotelRulesaaa: 'Enter the name list import rule',
        exhi: 'Events', // done
        deptSelect: 'Department Selection',
        auxQueries: 'Auxiliary Queries',
        company: 'Company',
        dept1: 'Level 1',
        dept2: 'Level 2',
        dept3: 'Level 3',
        dept4: 'Level 4',
        dept5: 'Level 5',
        dept6: 'Level 6',
        dept7: 'Level 7',
        dept8: 'Level 8',
        selected: 'Selected',
        loading: 'Loaded...',
        enterDept: 'Department codes or names can be entered',
        noDataInquire: 'No Data Queried',
        link: 'Link',
        pic: 'Image',
        clickUpDate: 'Click to Upload',
        textUpdateTips: 'Can only upload jpg/png/gif files and not more than 500kb',
        bold: 'Bold',
        italic: 'Italic',
        makeUnorderedList: 'Disordered',
        makeOrderedList: 'Ordered',
        Bookings: 'Bookings',
        contactName: 'Contact', // done
        contactInfo: 'Contact', // done
        plsEntCompany: 'Please fill company name',
        cancelConfirm: 'Yes,cancel this booking',
        bookTime: 'Booking Time', // done
        plsDetailAddress: 'Fill in the detailed address and do not repeat the provincial and urban areas', // done
        openingAccount: 'Account No.', // done
        inveiceType: 'VAT Special Invoice (Business)', // done
        vehicleTip1: 'Please select group number', // done
        vehicleTip2: 'Please enter  flight', // done
        vehicleTip3: 'Please select date', // done
        vehicleTip4: 'Please select airport',
        vehicleTip5: 'Please select/enter destination',
        vehicleTip6: 'Please enter the number of people',
        vehicleTip7: 'Please enter co',
        vehicleTip8: 'Please enter the comments',
        vehicleTip9: 'Select Vehicle',
        vehicleTip10: 'er an account or email address',
        actualEntry: 'Actual Check-in Entry',
        totalQuantity: 'Total Booked Volume in Peak Hours',
        stayQuantity: 'Total Check-in Volume in Peak Hours',
        totalOccupancy: 'Check-in Rate in Peak Hours',
        totalStay: 'Actual Check-in',
        totalStayPercentage: 'Actual Occupancy Rate',
        dateEntryScope: 'Date Entry Scope',
        recordingSucceeded: 'Recording Succeeded',
        bytesCannotExceed: 'The number of bytes cannot exceed 50',
        modificationTime: 'Modification Time',
        numberChange: 'Number of Changes',
        versionRecord: 'Version Record',
        groupNum: 'Group No',
        orderNum: 'Order No',
        directedDate: 'Directed Date',
        totalChanges: 'Total Number of Changes',
        totalChangeRate: 'Total Change Rate',
        selectModificationTime: 'Select a Modification Time.',
        beforeTheModification: 'Before the Modification',
        checkOutDate: 'Check-Out Date',
        changeType: 'Change Type',
        afterModification: 'After Modification',
        edit: 'Edit',
        enterMandatoryItems: 'Enter Mandatory Items.',
        preStep: 'Previous',
        enterCorrectAmount: 'Enter the Correct Amount.',
        theListChanged: 'The list has changed. Do you want to save the changes?',
        editedByAnother: 'The list is being edited by another user. Please try again later.',
        loadingFlightInformation: 'Loading Flight Information',
        enterUserValid: 'Enter a valid employee ID, W3 account, or full name',
        remarks: 'Remarks'
    },
    // common国际化
    common: {
        yes: 'Yes',
        no: 'No',
        close: 'Close',
        others: 'Others',
        Downtown: 'Downtown',
        price: 'Average Rate', // done
        nodata: 'No Data',
        save: 'Save', // 1
        submit: 'Submit',
        continueToAdd: 'Continue To Add',
        back: 'Return',
        search: 'Search', // 1
        reset: 'Reset',
        add: 'Add', // 1
        del: 'Delete', // 1
        import: 'Import',
        export: 'Export',
        view: 'View',
        tips: 'Tips',
        edit: 'Edit',
        privacyStatement: 'Privacy statement',
        privacyText: '为了帮助您和您的客户参加华为组织的展会、峰会、会议及访问中国，慧通需要为帮您或您的客户申请签证、安排住宿及车辆、购买机票等目的收集并处理您提交的个人数据（例如您提供的您个人和客户的护照扫描件，电话号码等），请您确认在提交个人数据前，了解并知悉我们的隐私声明，如果您代表您的客户提交个人数据，请您确保已经向您的客户尽到相应的告知义务，并且获得必要的授权。如您需要了解更多信息，可参阅隐私声明。',
        privacyText2: 'In order to help you and your clients participate in the exhibitions, summits, conferences that Huawei organizes and to arrange your visit in China, Smartcom will collect and process the Personal Data you provide (such as copies of passport, phone number of you and your clients etc.) for the purpose of arranging visa, accommodation, vehicular ,plane tickets, etc. Please understand and acknowledge our policies and get the authorization from the data subject for the above purpose before you submit any Personal Data. For more information, please refer to the privacy policy.',
        privacyRead: 'I have read and agree to the',
        sure: 'OK', // 1
        ok: 'Confirm',
        cancel: 'Cancel', // 1
        agree: 'Agree',
        reject: 'Reject',
        approved: 'Approved',
        disapproving: 'Revoked',
        revoked: 'Revoked',
        go: 'GO', // 1
        upload: 'Upload',
        operation: 'Opn', // 1
        coverImg: 'Main Diagram',
        setCoverImg: 'Set in the Main Map',
        uploadTip: 'Support only jpg, png; up to 3M per photo; at least 1 photo, up to a maximum of .0, recommended upload image size ratio 9:6（e.g. 1500*1000 | 900*600 | 240*160）',
        inputPlaceholder: 'Please Enter',
        selectPlaceholder: 'Please Choose',
        downloadTemp: 'Download the Template',
        imgPlaceholder: 'Please Upload an Image',
        orderDetail: 'Order Details', // 1
        checkMyWallet: 'Check my wallet', // 2
        address: 'Address', // 1
        amount: 'Total Amount', // 1
        name: 'Full Name', // 1
        phone: 'Mobile', // done
        email: 'Email', // 1
        distance: 'From', // done
        directDistance: 'About', // done
        someQueued: 'Some rooms need to be queued',
        allLined: 'All rooms need to be lined up',
        noneReserved: 'None of them can be reserved',
        someReserved: 'Some resources cannot be reserved',
        startUp: 'From', // done
        advSearch: 'Advanced Search',
        bookingNow: 'Book', // done
        contact: 'Contact',
        seeMore: 'View More', // 1
        more: 'More',
        shutUp: 'Closed',
        bookInst: 'Booking Instruction', // 1
        LocationOf: 'Location', // 1
        TraffCond: 'Traffic Conditions', // 1
        surrCond: 'Surroundings', // 1
        travelRoute: 'Routes', // 1
        collection: 'Add to Favorites', // 1
        cancelFavorite: 'Unfavorite', // 1
        share: 'Share', // 1
        gender: 'Gender', // 1
        isEmp: 'Employee', // 1
        position: 'Job', // 1
        requiredField: 'Required',
        selectRequired: 'Required',
        leave: 'Departure', // 1
        payWay: 'Method of Payment', // 1
        days: 'Days',
        vehicular: 'Vehicular',
        note: 'Remarks', // 1
        vehicleRemark: 'Please provide detailed vehicle information here, such as the route, flight number, train number, and other vehicle information.', // 1
        switchGroup: 'Change Group', // 1
        guestBing: 'Guest',
        man: 'Man',
        women: 'Woman',
        createApplication: 'Create an application',
        cancelAttendance: 'Cancel Attendance',
        placeholder: {
            pleaseSelectCity: 'Please Select A City',
            pleaseSelectCountry: 'Please select a country first',
            pleaseSelectProvince: 'Please select a province first'
        },
        log: {
            title: 'Log',
            operationUser: 'Operator',
            operationDate: 'Operation Time'
        },
        tip: {
            confirmOperation: 'Are you sure you want to perform the current operation?',
            selectData: 'Please select at least one piece of data',
            delConfirm: 'Confirm deleting the current data?',
            delSuccess: 'Removal Successful',
            delFailed: 'Failed to Delete',
            abolitionSuccess: 'Abolition success',
            abolitionFailed: 'Failed to abolition',
            saveSuccess: 'Saved Successfully',
            sveFailed: 'Saved Failed',
            exportSuccess: 'Export Successful',
            exportFailed: 'Export failed, please try later',
            importSuccess: 'Import Success',
            importFailed: 'The import failed, please try later',
            imgUploadFailed: 'Image Upload Failed',
            imgUploadLimit: 'The number of pictures exceeds the limit!',
            startTimeRequire: 'Please select the start time',
            endTimeRequire: 'Please select the end time',
            timeOutRange: 'The time you selected is not in the available time range, please reselect',
            dataChange: 'Date cannot be selected for the day!',
            allocation: 'Allocation Succeeded.',
            delChenkInPeople: 'The check-in person will be deleted. Are you sure you want to continue',
            isCancelModify: 'The list has changed. Do you want to cancel the modification?',
            updateSuccess: 'Update successful ',
            updateFailed: 'Update failed '
        },
        valid: {
            enterCorrectIdCardNum: 'Please enter a correct ID card number.',
            enterCorrectIdPassportNum: 'Please enter the correct passport number.',
            enterIssuedBy: 'Please enter the correct passport issuing place',
            enterPhoneNum: 'Please enter a correct mobile number'
        },
        importing: 'Importing',
        outsideLinkTips: 'You are about to open an external link. Do you wish to proceed?',
        privacyTips: 'The exported page data contains sensitive information. Please handle it with care and ensure it is used or stored in a secure environment!'
    },
    // 菜单
    menu: {
        personalCenter: 'User Center', // 1 done
        exhiConfig: 'Show Configuration',
        resourcesConfig: 'Resource Configuration',
        hotelConfig: 'Hotel Configuration',
        planeTickets: 'Plane Ticket Configuration',
        trainTickets: 'Train Ticket Configuration',
        leisureRes: 'Leisure Configuration',
        userPerm: 'User Rights Configuration',
        systemManage: 'System Management',
        roleManage: 'Role Management',
        permManage: 'Rights Management'
    },
    leftMenu: {
        recentOrders: 'Recent Orders', // 1
        hotelOrders: 'Hotel Orders', // 1
        vehicleOrders: 'Vehicle Orders',
        applicationManagement: 'My To-Do',
        switchConfig: 'Switch Config',
        airTicketOrders: 'Ticket Orders',
        leisureResourceOrders: 'Leisure Orders',
        personalInfo: 'User Info', // done
        commonContacts: 'Contacts', // done
        commonAddress: 'Common Addresses', // 1
        commonInvoice: 'Common Invoices', // 1
        myImportExport: 'My Import & Export',
        commonInformation: 'Common Information',
        myFavorites: 'My Favorites', // 1
        myMessage: 'My Message',
        help: 'Help', // 1
        orderManagement: 'Order Management',
        businessQueueOrders: 'Business Queue Orders',
        privacyPolicy: 'Privacy Policy',
        personManage: 'Person Manage',
        BusinessStatistics: 'Business Travel Booking Statistics'
    },
    // element组件
    el: {
        colorpicker: {
            confirm: 'OK', // 1
            clear: 'Clear'
        },
        datepicker: {
            date: 'Date',
            now: 'Now',
            today: 'Today',
            cancel: 'Cancel', // 1
            clear: 'Clear',
            confirm: 'OK', // 1
            selectDate: 'Select a Date',
            selectDateTime: 'Select a date and time',
            selectTime: 'Select a Time',
            startDate: 'Start Date',
            startTime: 'Start Time',
            endDate: 'End Date',
            endTime: 'End Time',
            prevYear: 'Previous Year',
            nextYear: 'One Year Later',
            prevMonth: 'Last Month',
            nextMonth: 'Next Month',
            year: 'Year',
            month: 'Month',
            month1: 'January',
            month2: 'February',
            month3: 'March',
            month4: 'April',
            month5: 'May',
            month6: 'June',
            month7: 'July',
            month8: 'August',
            month9: 'September',
            month10: 'October',
            month11: 'November',
            month12: 'December',
            // week: '周次',
            weeks: {
                sun: 'Sun.',
                mon: 'Mon.',
                tue: 'Tues.',
                wed: 'Wed.',
                thu: 'Thur.',
                fri: 'Fri.',
                sat: 'Sat.'
            },
            months: {
                jan: 'January',
                feb: 'February',
                mar: 'March',
                apr: 'April',
                may: 'May',
                jun: 'June',
                jul: 'July',
                aug: 'August',
                sep: 'September',
                oct: 'October',
                nov: 'November',
                dec: 'December'
            }
        },
        select: {
            loading: 'Loaded',
            noMatch: 'No Matching Data',
            noData: 'No Data',
            placeholder: 'Please Choose'
        },
        cascader: {
            noMatch: 'No Matching Data',
            loading: 'Loaded',
            placeholder: 'Please Choose'
        },
        pagination: {
            goto: 'Go', // 1
            pagesize: 'Records/Page', // 1
            total: '{total} in Total',
            pageClassifier: 'Page' // 1
        },
        messagebox: {
            title: 'Tips',
            confirm: 'OK', // 1
            cancel: 'Cancel', // 1
            error: 'The data entered is illegal!'
        },
        upload: {
            deleteTip: 'Press delete to delete',
            delete: 'Delete', // 1
            preview: 'View Pictures',
            continue: 'Continue Uploads'
        },
        table: {
            emptyText: 'No Data',
            confirmFilter: 'Screening',
            resetFilter: 'Reset',
            clearFilter: 'All',
            sumText: 'Total'
        },
        tree: {
            emptyText: 'No Data'
        },
        transfer: {
            noMatch: 'No Matching Data',
            noData: 'No Data',
            titles: ['Listing 1', 'Listing 2'],
            filterPlaceholder: 'Please enter the search content',
            noCheckedFormat: '{total} in Total',
            hasCheckedFormat: 'Selected for the item of {checked}/{total}'
        },
        image: {
            error: 'Failed to Load'
        }
    },
    // 头部 Header.vue国际化
    header: {
        exhiHome: 'Home', // 1
        home: 'Home', // 1
        hotel: 'Hotel', // 1
        vehicle: 'Vehicle', // 1
        airTicket: 'Flight', // 1
        trainTicket: 'Train', // 1
        leisureResources: 'Leisure', // 1
        login: 'Sign In', // done
        logout: 'Sign Out', // done
        dearUser: 'Dear user:',
        tips1: 'For better using-experience, you are advised to register a Huawei ID for  EventsGO account to reserve resources.',
        tips2: 'To use another account such as QQ, WeChat, or Linkedin , please login on moblie.',
        qrcode: 'Scan the QR code on the mobile phone to access the page.',
        close: 'Close in {0} seconds',
        lang: '中文', // 英文模式下这里显示中文
        myOrder: 'My Orders', // 1
        hotelOrders: 'Hotel Orders', // 1
        vehicleOrders: 'Vehicle Orders',
        applicationManagement: 'My To-Do',
        personalCenter: 'User Center', // 1 done
        exhiConfig: 'Events Configuration', // done
        switchConfig: 'Switch Config',
        mediaPersonnel: 'Personnel',
        resourcesConfig: 'Resource Configuration'
    },
    // 底部 Footer.vue国际化
    footer: {
        copyRight: 'Copyright © 2019 Smartcom. All rights reserved', // 1
        contactUs: 'Contact', // done
        confirmRevoked: 'Are you sure you want to cancel it?', // 您确定要撤销吗？
        statement: 'Privacy', // done
        complaint: 'Report bad information'
    },
    // 资源首页 Exhi.vue国际化
    exhi: {
        hotHotel: 'Popular Hotels',
        vehicleService: 'Vehicle Service', // 1
        ticketService: 'Popular Flights', // done
        trainService: 'Popular Trains', // done
        leisureResources: 'Leisure', // 1
        timeTip: 'The time you have selected is not within available range, please re-select',
        lockTip: 'The check-in date is within the locked range and cannot be reserved. Please select another date.'
    },
    // 资源首页_Banner组件 Banner.vue国际化
    banner: {
        hotel: 'Hotel', // 1
        vehicle: 'Vehicle', // 1
        ticket: 'Flight', // 1
        trainTickets: 'Train', // 1
        leisureResources: 'Leisure' // 1
    },
    // 资源首页_用车服务组件 VehicleBlock.vue国际化
    vehicleService: {
        meetCar: 'Pick-up',
        offCar: 'Drop-off',
        theTrip: 'Per Trip/Per Car',
        noGroupTips: 'You do not currently have approved groups and can be completed on the icims system',
        groupApp: 'Group Application',
        postCarApp: 'Apply for a car again, thank you.',
        gotIt: 'Got It'
    },
    // 资源首页_Banner搜索组件 Search.vue国际化
    search: {
        personal: 'Individual Tourist', // 1
        hotelName: 'Hotel Name',
        address: 'Address', // 1
        reSearch: 'Search', // 1
        endTime: 'End Time',
        startTime: 'Start Time',
        changeTip: 'Have you modified the query criteria to re-acquire hotel resources for you to start?',
        noMoreRemind: 'OK, no more reminders later',
        moreRemind: 'OK, remind me every time.'
    },
    hotelListC: {
        searchFor: 'Search Result：{0} Hotel', // done
        searchFor2: 'Search Result：{0} Hotels', // done
        home: '', // 为您搜索到多少家酒店的'家'
        hotel: 'Hotel', // 1
        stars: 'Star Rating', // done
        noSearchData: 'No records that meet the query criteria',
        hotelProfile: 'About Hotel', // 1
        checkRoomType: 'Room Type', // 1
        browseHistory: 'Browse History', // Done
        returnList: 'Back to List',
        centerDistance: 'Distance from Convention and Events Center',
        venueDistance: 'Distance' // done
    },
    // 酒店列表-酒店搜索筛选组件 AdvancedFilter.vue,PersonalAdvancedFilter.vue,BusinessAdvancedFilter.vue国际化
    advancedFilter: {
        priceRange: 'Average Rate', // done
        hotelStars: 'Star Rating', // done
        locationArea: 'Location', // 1
        advancedSearch: 'Advanced Filtering', // 1
        emptyFilter: 'Clear', // 1
        priceRangeInt: 'Please enter the number 0-999999999',
        priceRangeTip: 'Price range Start price cannot be greater than the end price',
        notLimited: 'Not Limited', // 1
        pavilion: 'Hall', // 1
        hotSort: 'Recommended' // done
    },
    // 酒店列表 - 查看房型组件 BookRoomType.vue,BusinessBookRoomType.vue,PersonalBookRoomType.vue国际化
    checkRoomType: {
        newAllowance: 'Number of unused rooms',
        hasSelected: 'Selected',
        room: 'Room', // 1
        priceAll: 'Average Rate', // done
        roomType: 'Room Type',
        allowance: 'Vacancies', // 1
        maximunAllowancePerDay: 'maximun allowance per day',
        allowanceDetail: 'Vacancy Details', // 1
        queuDetail: 'Queuing Details', // 1
        personNum: 'Standard Occupancy', // done
        roomTypeState: 'Room Type State',
        selQuantity: 'Select Quantity',
        houseType: 'House Type',
        addReservation: 'Add Reservation',
        addReservationPd: 'Add a queue',
        added: 'Added',
        dateNotEmpty: 'Date Cannot be Empty',
        selectRoomNum: 'Please select a room type',
        groupRange: 'You have no reservations for the hotel\'s group, the hotel only VIP plus group can be booked, if you need to book please apply for that level in icims first',
        noRoom: 'All Rooms are Missing',
        queue: 'There are {0} people in line',
        queueing: 'Now {0} people are in line',
        choiceOtherRoom: 'It is recommended that you choose another room type or a hotel with sufficient room volume',
        notEnoughRoom: 'Insufficient Margin',
        waitingDate: '{0} days of missing room queue, modified date can be booked in advance successfully',
        buildingArea: 'Area',
        roomTypeDetail: 'Room Details',
        seeMore: 'Details', // done
        bedType: 'Bed Type', // 1
        breakfast: 'Breakfast',
        noBreakfast: 'No Breakfast',
        singleMorning: 'A Breakfast',
        doubleMorning: 'Two Breakfasts',
        containsEarly: 'Includes Breakfast',
        plicy: 'Policy',
        timeLimitedCancel: 'Time-Limited Cancellation',
        freeOfCancel: 'Free Cancellation',
        Uncancelable: 'Non Cancelling',
        partfull: 'Partfull',
        fullRoom: 'Full Room',
        singleBed: 'A Bed',
        twinBeds: 'Two Beds',
        queenBed: 'Queen Bed',
        roundBed: 'Round Bed',
        reserAvail: 'Available', // 1
        queuRequired: 'Queuing' // 1
    },
    // 预订流程-Reservation.vue及其子组件国际化
    reservation: {
        roomTypeNull: 'Room Type Cannot be Empty!',
        completeApplication: 'Hotel Booking Complete', // 1
        harfCountRequire: 'Please enter the correct half-out amount',
        requestfailed: 'Order Detail Request Failed',
        confirm: 'Confirm', // 1
        submittedSuccessfully: 'Submitted successfully. Waiting for vehicle administrator to arrange',
        waiting: 'Waiting', // 1
        rowStatu: 'Room Status', // 1
        addPerson2: 'Add Occupant', // 1
        stay: 'Arrival', // 1
        addUstomer: 'Add Occupant', // 1
        bookRoomType: 'Room Type', // 1
        bookHotel: 'Hotel Booking', // 1
        HotelDetailshotelPolicycontent: 'The rules set by the hotel are subject to the booking.',
        hotelPolicypersonal: 'Hotel Policy:',
        hotelPolicy: 'Terms & Conditions: The agreement price can be enjoyed only when the monthly settlement is performed. The current payment is based on the front end price.', // 1
        businessTip: 'Check-in time cannot be earlier than current time and cannot be greater than check-out time',
        inOutTime: 'Arrival/Departure Time', // 1
        household: 'Occupant', // 1
        state: 'State',
        stayInfo: 'Order Information', // 1 // done
        night: 'Night(s)',
        deleteRoomType: 'Delete Room Type',
        inOutDate: 'Check In/Out', // done
        roomNum: 'Room Quantity', // 1
        tipsDefaultTime: 'Please fill in the customer arrival time, the default hotel check-in time is 15:00, check-out time is 12:00',
        must1day: 'Selected time span must be greater than one day',
        must1cust: 'Add at least one customer',
        confirmCancel: 'Confirm the request to remove the room?',
        groupChange: 'The current booking request can only select the same group of customers, has now added a group of customers, do you want to empty the added customer information?',
        selectCust: 'Please select a guest',
        roomMaxCust: 'Up to {0} people per room',
        oppositeSex: 'Are you sure you can arrange a co-room for a man and a woman?',
        rebook: 'Select customer {0} with a booking success status, please confirm whether to rebook?',
        cancelRoomType: 'Are you sure to cancel the room type application?',
        selectGroup: 'Select Group', // 1
        selectGroupPls: 'Please select group', // 1
        groupplaceHolder: 'Group number sits or visitor units can be entered for search',
        visiUnit: 'Company', // 1
        groupNo: 'Group NO.', // 1
        changeRoomType: 'Modify', // done
        changeRoomTypeTj: 'Add Room Type', // done
        oneRoom: '', // 间，量词，因英文无量词，所以暂时先空白
        oneRoomY: '', // 间，量词，因英文无量词，所以暂时先空白
        confirmOrderInfo: 'Confirm Order Information',
        orderFailed: 'Order Submission Failed',
        bookPersonInfo: 'Booking Information', // 1
        contactInformation: 'Contact information',
        areaName: 'Regional Department',
        areaNameEmptyTip: 'Region cannot be empty.',
        AmountPay: 'Total Amount Due', // 1
        submitOrder: 'Submit Order', // done
        exceedBudget: 'The group has exceeded the budget and needs to be budgeted for additional or resource release',
        plusbudget: 'Additional Budget',
        emailMsgTwo: 'The Email is Required',
        emailMsgOne: 'Please enter the correct mailbox format',
        phoneMsgOne: 'Cell Phone Number is Required',
        nameMsgOne: 'Name is Required',
        accommInfoComf: 'You have accommodation information not filled in or filled in information is not confirmed, please check the information first',
        ordersubmitsuccess: 'Your Order Has been Submitted!',
        confirmText: 'Room for booking success status has been arranged;',
        waitingText: 'The room in the waiting position will be arranged as appropriate, please keep an eye on it!',
        carService: 'Vehicle Service', // 1
        occupancyInfo: 'Order Information', // done
        addHotel: 'Add a Hotel',
        fromEMS: 'Group information from EMS system',
        departName: 'Requirements Department Name',
        belongsBG: 'Owned BG',
        customerCategory: 'Customer Category',
        applicant: 'Applicant',
        contact: 'Contact',
        totalBudget: 'Total Budget',
        qroupQueueTip: 'The group is already in line, please re-select the other group',
        plsEnterInteger: 'Please enter a positive integer',
        roomTypeNoEmpty: 'Room Type Cannot be Empty',
        currHotelTip: 'The current hotel retains at least one room type',
        plsPerfectInfo: 'Please perfect the required information',
        price: 'Average Rate', // done
        num: 'Number',
        cost: 'Room Price', // 1
        totalCost: 'Total Cost', // 2
        subtotalCost: 'Subtotal Cost', // 2
        submitSuccess: 'Submitted.',
        choiceHotel: 'Choose a Hotel',
        searchPlaceholder: 'Please enter the hotel name/address to search',
        hotelPic: 'Hotel Pictures',
        hotelName: 'Hotel Name',
        stars: 'Star',
        addRoomType: 'Add Room Type',
        changeHotel: 'Switch Hotels',
        isConfirm: 'Confirm the Booking',
        enterGroupNo: 'Enter Group Number',
        updateSuccess: 'The Update was Successful',
        atLeastOneHotel: 'Keep at least one hotel on current order',
        tipMsg: '1 guest at least and 2 at most. The names must be the same as those on the ID cards for check-in.', // done
        addPerson: 'Guest Name',
        saveContact: 'Save Contacts', // done
        plsEnterName: 'Please enter your name',
        plsEnterEmail: 'Please enter the email',
        invoice: 'Invoice Delivery', // done
        noNeed: 'Don\'t Need', // done
        need: 'Need',
        invoiceTip1: 'Announcement of the State Administration of Taxation: From July 1, 2017, invoices offered to companies must include a taxpayer identification.', // done
        invoiceTip2: 'Tips: Please fill in the information according to the actual registration information of the company. If the content is incorrect, the platform ', // done
        invoiced: 'Issue Invoice', // done
        canBeIssued: '5 invoices of different/same amounts can be issued',
        invoiceCost: 'Amount of Invoice {0}',
        plsInvoiceHeadUp: 'Please enter the invoice to look up',
        plsCompanyAddress: 'Please enter the company address',
        plsCompanyTel: 'Please enter the company phone number',
        plsBankName: 'Please enter the name of the bank that opened the account',
        plsBankAccount: 'Please enter the bank account number',
        plsCountry: 'Please choose a Country',
        plsTaxpayerIdentificationNum: 'Please enter the taxpayer identification number',
        identificationTips: 'The tax number on the tax register, which identifies the business, usually consists of 15, 18 or 20 codes.',
        invoiceIndicate: 'Invoice indicates hotel name and departure time',
        selfCosts: 'Self-responsible courier costs',
        mailAddress: 'Address', // done
        addAddress: 'Add Address', // done
        plsRecipient: 'Please enter the recipient\'s name',
        recipientName: 'Recipient\'s Name',
        recipient: 'Recipient',
        ChoiceArea: 'Province/City/District', // done
        location: 'Location',
        plsDetailedAddress: 'Please fill in the detailed address',
        streetInfo: 'Street Information',
        detailedAdderssTip: 'Please fill in the detailed address, do not need to repeat the filling in the provincial and municipal',
        zipCode: 'Zip Code',
        plsZipCode: 'Please fill in the zip code',
        addressTip: 'If confirmed, it will be saved as a common shipping address',
        completeRead: 'I have read and accepted the 《cancel policy》', // done
        plsPhoneMsg: 'Please enter the correct phone number',
        plsEmailMsg: 'Please enter the correct email address',
        plsCountryMsg: 'Please select the country number',
        plsInteger: 'The fill-in invoice amount must be a positive integer',
        plsInvoiceCost: 'The cumulative value of multiple invoices must be equal to the invoice amount',
        plsRightTel: 'Please enter the correct phone number, such as:{0}',
        bankLength: 'Bank account number is 9-50 characters',
        taxNoLength: 'The length of the tax number is 15, 18, 20',
        addressLength: 'Unit addresses support only 5-85 characters, 3 characters in one character',
        plsRoomStay: 'Please fill in the room occupancy',
        plsBookName: 'Please fill in the name of the person booking',
        plsBookPhone: 'Please fill in the subscriber\'s mobile phone',
        plsBookEmail: 'Please fill in the subscriber\'s email address',
        guaranteeNote: 'Default Notes Required',
        noCompany: 'No common lying companies are looking up',
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        countInvoice: '{0}',
        nextDay: '00:00(Next day)',
        floor: 'Floor', // 1
        roomCost: 'Room Price', // 1
        payOnline: 'Online Payment',
        youSelected: 'You have Selected',
        to: 'To',
        total: 'Total',
        aRoom: 'Room',
        custplaceHolder: 'Enter a Name.', // 1
        person: 'person',
        addcust: 'Add Guests'
    },
    // 酒店资源配置详情国际化
    hotelResDetail: {
        roomTypeName: 'Room Type Name',
        hotelBasicInfo: 'Hotel Basics',
        roomTypeInfo: 'Room Type', // 1
        roomNumInfo: 'Room Volume Information',
        hotelOverview: 'Hotel Overview',
        plsEnterType: 'Please enter the room type',
        plsSelectType: 'Please choose the room type',
        company: 'Company',
        personal: 'Personal',
        business: 'Business',
        empty: 'Clear',
        referencePrice: 'Reference Price',
        companyRoomNum: 'Company Room Volume',
        businessRoomNum: 'Personal Room Volume',
        personalRoomNum: 'Business Room Volume',
        hotelNameCn: 'Hotel Name (Chinese)',
        hotelNameEn: 'Hotel Name (US)',
        hotelBrand: 'Hotel Brands',
        customerLevel: 'Customer Level',
        whetherToBook: 'Can be Booked',
        bookingMail: 'Email for Booking',
        openDate: 'Opening Time',
        renovationYears: 'Renovation Years',
        openingHours: 'Business Hours',
        roomCount: 'Number of Rooms',
        checkInTime: 'Earliest Check-in Time',
        checkOutTime: 'Latest Departure Time',
        isHot: 'Is it recommended',
        hotSort: 'Sort By', // 1
        hotelTel: 'Hotel Customer Service Phone',
        hotelFax: 'Hotel Fax',
        contactName: 'The Person Responsible for the Hotel',
        tel: 'Phone', // done
        feature: 'Hotel Features',
        introductionCn: 'Hotel Profile (Chinese)',
        introductionEn: 'Hotel Profile (US)',
        location: 'Location',
        domesticInternational: 'Domestic/International',
        domestic: 'Domestic',
        international: 'International',
        country: 'Countries',
        city: 'City',
        districtCode: 'District', // 1
        baiduCoordinate: 'Coordinates of Baidu Map',
        googleCoordinate: 'Coordinates of Google Maps',
        hotelAddressCn: 'Hotel Address (Chinese)',
        hotelAddressEn: 'Hotel Address (US)',
        locationArea: 'Location',
        hotelPic: 'Hotel Pictures',
        hotelFacilities: 'Hotel Facilities', // 1
        publicFacilities: 'Public Facilities',
        meetingFacilities: 'Conference Services',
        diningFacilities: 'Hotel Dining Facilities',
        freeFacilities: 'Free Hotel Facilities',
        guestRoomFacilities: 'Hotel Room Facilities',
        otherFacilities: 'Other Facilities'
    },
    // 个人酒店订单列表 & 详情
    personalOrder: {
        bookingDate: 'Book Date', // 1
        plsChoiceDate: 'Please select the booking date',
        toPay: 'Pay Now', // 1
        payMethod: 'Payment Type', // done
        actualAmount: 'Total Pay', // done
        serviceAmount: 'Tax Service Charge Included',
        reachTime: 'Arrival Time', // 1
        basedOnLocalTime: 'The Local Time Prevails', // 1
        occupancyInfo: 'Order Information', // done
        invoiceInfo: 'Invoice Information', // 1
        invoiceType: 'Invoice Type',
        specificInvoice: 'VAT Special Invoice', // done
        invoiceDetails: 'Invoice Detail', // done
        bookingAccommodation: 'Accommodation Fee', // 1
        companyFullName: 'Company Full Name', // done
        companyAddress: 'Company Address', // 1
        companyTel: 'Telephone', // done
        invoiceAmount: 'Invoice Amount', // 1
        bankName: 'Taxpayer\'s Bank ', // done
        bankAccount: 'Bank Account Number', // done
        taxpayerIdentificationNum: 'Taxpayer Identification Number', // done
        whetherToIndicate: 'Whether to indicate the name of the hotel and the date of departure',
        invoicesDeliver: 'How to Deliver Invoices',
        express: 'Express(Pay By Recipient)', // done
        himself: 'Pick Up(Huawei Base F1-17 Floor)', // done
        invoicesExpressInfo: 'Invoice Courier Information',
        invoicesHimselfAddress: 'Invoice Self-fetched Address',
        noInvoices: 'No Invoice Required',
        ifNeedInvoices: 'To request an invoice, please contact', // 1
        cancelRule: 'Cancel Policy', // done
        cancelRuleTextTip: 'Read carefully. If you cancel the cancellation within the specified time, contact customer service (0755-28566666).',
        Individualbookinghotelcancellationrulecontent: 'Due to the tight supply during the Events, the order needs to be prepaid, after confirmation can not be cancelled changes, such as the full room rate and full service charge will not be refunded, total{CurrencyUnit}{Amount}。',
        noInvoicescontent: 'This invoice will be issued by Smartcom and will be invoiced 7-15 working days after you leave the hotel and will be notified of your', // done
        orderTipStart: 'After being prepaid, orders cannot be modified or canceled after', // 1
        stayDate: 'Check-in Date',
        orderTipEnd: ' If you do not check in, the first-day room fee will not be refunded.' // 1
    },
    // 车辆相关
    vehicleInfo: {
        receiveSignTip: 'Content should not be too long, it is recommended to fill in the customer\'s company name',
        minprice: 'From', // done
        requireTip: 'Please fill in the time of use of the car',
        vehicheInfo: 'Vehicle Information',
        howArive: 'Transport for Arrival',
        howLeave: 'How to Leave',
        flight: 'Flight No',
        leaveTime: 'Departure Time',
        departureTips: 'It is recommended to depart 3 hours ahead of departure time',
        meetPlace: 'Airport',
        departure: 'Departure Location',
        placeDelivery: 'Destination',
        pickCard: 'Pick-up Sign',
        userInfo: 'User Information',
        custNumber: 'Number of Guests',
        escortNumber: 'Huawei Staff',
        callNumber: 'Call',
        meetCar: 'Pick-up',
        offCar: 'Drop-off',
        meetCarApp: 'Welcome Car Applications',
        offCarApp: 'Application for a Drop-off Car',
        ridersNumber: 'Number of Riders',
        theTrip: 'Per Trip/Per Car',
        intLength1: 'Please enter 1-999999 positive integer',
        intLength0: 'Please enter 0-999999 positive integer',
        charLength: 'The length of characters entered exceeds the limit',
        vehConfigTips: 'No vehicle-related configuration information was queried',
        groupDudgetTips: 'Group over budget, whether to add budget, click OK to jump to the add-on budget page',
        orderProces: 'Order Process Guide',
        selectVehTime: 'Choose a Car Time',
        selectVehType: 'Choose the type of car you use',
        vehType: 'Types of Car Use',
        selectNeedVehTyp: 'Choose the type of car you want',
        fillOrder: 'Fill in the Order',
        fillVehInfo: 'Fill in the car information and user information',
        successSubOrder: 'Successfully Submitted Order',
        confirmCarInfo: 'Confirm successful submission of car information',
        waitDelivery: 'Waiting for a Delivery',
        waitAcceptDeli: 'Waiting for the receiving car to start the journey',
        reSearch: 'Search', // 1
        noGroupTips: 'You do not currently have approved groups and can be completed on the icims system',
        groupApp: 'Group Application',
        postCarApp: 'Applying for a car again, thank you',
        gotIt: 'Got It',
        viewUpOffIssues: 'View Transfer-related Questions',
        stayTuned: 'This feature is under construction, so stay tuned!',
        orderNo: 'Order No.', // 1
        meet: 'Airport', // done
        meetMeta: 'Pick-up', // done
        off: 'Drop-off', // done
        letGo: 'Departure',
        arrived: 'Arrived',
        served: 'Served',
        time: 'Time',
        schedDate: 'Booking Date', // 1
        flightNo: 'Flight No.',
        carOrder: 'Car Orders',
        queryConditionTit: 'Order No./Group No./Departure/Destination',
        orderState: 'Order Status',
        byCarDate: 'Date of Use',
        inputByCarDate: 'Please enter the date of your car',
        inputSchedDate: 'Please enter the booking date',
        arrivalTime: 'Arrival Time',
        departureTime: 'Departure Time',
        modifOrder: 'Modify Order', // 1
        bookAgain: 'Book Again', // 1
        driverInfo: 'Driver Information',
        carType: 'Models of Car',
        carCard: 'License Plate',
        driverName: 'Driver\'s Name',
        cancelOrder: 'Cancel Order', // 1
        cancelTips: 'Please confirm whether you want to cancel your reservation?', // done
        submitted: 'Submitted', // 1
        accepted: 'Accepted',
        carDispatched: 'Car Dispatched',
        inPlace: 'In Place',
        onBoard: 'In the Car',
        evaluated: 'To be Evaluated',
        completed: 'Completed',
        cancelled: 'Cancelled',
        orderCancelSucc: 'Order Cancellation Successful',
        needNoshowFee: 'According to the cancellation rule, the Noshow fee {0} will be deducted for this operation. Are you sure you want to continue?', // 按照取消规则规定，本次操作将扣除Noshow费{0}，请确认是否继续执行？
        orderCancelfailed: 'Order Cancellation Failed',
        contact1: 'Contact1',
        contact2: 'Contact2',
        contactPhone1: 'Contact Phone 1',
        contactPhone2: 'Contact Phone 2',
        evaluation: 'Evaluation',
        carService: 'Vehicle Service', // 1
        marginPreview: 'Margin Preview',
        enterTheVehicleQuantity: 'Enter the Vehicle Quantity',
        usage: 'Usage',
        selectaDuration: 'Select a Duration',
        enterTheNumber: 'Enter the number of vehicles used per day.',
        insufficientNumber: '[{0}] Insufficient resources. Please reselect or submit for queuing.',
        maximumTip: 'A maximum of 165 Chinese characters or 500 English letters and digits can be entered.',
        selectaUsage: 'Select a Usage.',
        selectaVehicle: 'Select a vehicle model.',
        selectTheVehicle: 'Select the vehicle use start time.',
        selectTheVehicleTime: 'Select the vehicle use end time.',
        customerReception: 'Customer Reception',
        pleaseReserve: 'Please reserve at least one record.',
        numberOf: 'Number of Passengers',
        enterTheChinese: 'Enter a vehicle model name.',
        prearranged: 'Prearranged',
        car: 'Car',
        estimatedPayment: 'Estimated Payment',
        draft: 'Draft',
        waitingForVehicle: 'Waiting for Vehicle Group to Handle',
        closed: 'Closed',
        selectDate: 'Select Date',
        numberOfPersonnel: 'Number of Personnel on Board',
        dailyUsage: 'Daily Usage',
        dailyTime: 'Daily Time Required',
        addReservation: 'Add Reservation',
        addingaqueue: 'Adding a Queue',
        reservationExpired: 'Reservation Expired',
        amaximum: 'A maximum of five dedicated vehicle orders can be added.',
        batchBooking: 'Batch Booking',
        contentChanged: 'Content changed. Are you sure you want to exit?',
        theBackgroundDoes: 'The background does not return the order ID.',
        failedToSubmitTheOrder: 'Failed to Submit the Order.',
        pleaseSetMandatoryParameters: 'Please set mandatory parameters.',
        businessTravel: 'Pick-up by Business Travel',
        theApplication: 'The application has been submitted successfully. Please continue to pay attention to vehicle dispatching!',
        helloYour: 'Hello, your',
        orderListQuery: 'Order List Query',
        queryError: 'Query Error',
        businessTravelVehicle: 'Business Travel Vehicle',
        requestingDepartment: 'Requesting Department',
        addVehicle: 'Add Vehicle',
        editBusiness: 'Edit Business Travel Vehicle',
        addBusiness: 'Business travel vehicle application',
        juncture: 'Juncture',
        staked: 'Staked',
        endTimeTip: 'The end time must be later than the start time.',
        noIntroduction: 'No vehicle introduction',
        hour: 'Hour',
        noDate: 'No Booking Dates Available',
        hou: 'hour',
        day: 'day'
    },
    // 机票、火车票、休闲资源推荐
    otherResources: {
        ticket: 'Popular Flights', // done
        trainTickets: 'Popular Trains', // done
        leisureResources: 'Leisure', // 1
        starts: 'From', // done
        discount: 'off'
    },
    // 资源配置国际化
    resourcesConfig: {
        breadcrumb: {
            hteol: 'Hotel Resource Configuration',
            rule: 'Hotel Rules',
            res: 'Resource Configuration'
        },
        hotelList: {
            tab: {
                hteol: 'Hotel Configuration',
                rule: 'Resource Configuration'
            },
            all: 'All',
            hotelName: 'Hotel Name', // 1
            hotelFrom: 'Source of Resources',
            stars: 'Star Rating', // done
            address: 'Hotel Address', // 1
            isEnable: 'Can be Booked',
            isHot: 'Recommended Hotels',
            hotSort: 'Recommended', // done
            edit: 'Edit Hotel',
            add: 'New Hotels',
            addRoomType: 'Add Room Type',
            exportHotel: 'Hotel Information Export',
            exportImportRoom: 'Room type volume import and export',
            importRoom: 'Room Type Import',
            exportRoom: 'Room Type Volume Export',
            hotelNamePlaceholder: 'Please enter the name of the hotel',
            tip: {
                delConfirm: 'Please confirm that the {0} hotel and its related configuration room type, room volume information?',
                hotelReference: 'The {0} hotel has been referenced, not allowed to delete, please first empty the configuration information under the hotel!'
            }
        },
        roomType: {
            name: 'Room Type', // 1
            nameCn: 'Room Type (Chinese)',
            nameEn: 'Room Type (US)',
            windowType: 'Window Type',
            area: 'Area（M²）',
            floor: 'Floor', // 1
            bedType: 'Bed Type', // 1
            bedTypeLength: 'Bed Length (m)',
            bedTypeWidth: 'Bed Width (m)',
            averagePrice: 'Average House Price',
            serviceFee: 'Average Service Charge',
            businessType: 'Type of Business',
            businessTypes: {
                company: 'Business Partner', // 1
                individual: 'Individual Tourist', // 1
                business: 'Business Traveller' // 1
            },
            addRoomQuantity: 'Add Room Volume',
            editRoomQuantity: 'Editing Room Volume',
            dialog: {
                viewRoomType: 'Room Type', // 1
                addTitle: 'New Room type',
                editTitle: 'Editing Room Type'
            },
            windowTypes: {
                yes: 'Has Window',
                no: 'No Window'
            },
            roomTotal: 'Total Number of Rooms',
            whetherToBook: 'Can be Booked',
            whetherToBooks: {
                yes: 'Available', // 1
                no: 'Cannot be Booked'
            },
            index: 'index',
            internetType: 'Internet Access', // 1
            internetTypes: {
                wireless: 'Wi-Fi',
                wired: 'Wired Internet',
                no: 'No Network'
            },
            image: 'Room Picture',
            valid: {
                nameCnRequired: 'Please enter the name of the room Chinese',
                nameEnRequired: 'Please enter the English name of the room type',
                nameCnRequiredTravel: 'Please choose the room type',
                priceRequired: 'Please enter the price',
                averagePriceRequired: 'Average house prices cannot be empty',
                roomCountRequired: 'Please enter the total number of rooms',
                nameValid: 'Enter up to 33 Chinese characters or 100 English letters and numbers',
                imgSize: 'Upload image size cannot exceed 3M!'
            }
        },
        roomQuantity: {
            dateRange: 'New room volume date range',
            date: 'Date',
            quantity: 'Amount Allocated',
            remaining: 'Margin',
            status: 'Room Status', // 1
            quote: 'Quote',
            serviceFee: 'Service Charge',
            noBreakfast: 'No Breakfast',
            singleMorning: 'A Breakfast',
            doubleMorning: 'Two Breakfasts',
            containsEarly: 'Includes Breakfast',
            valid: {
                required: 'Please enter the amount allocated',
                range: 'The edited room volume must not be less than the difference between the current room volume and the margin'
            }
        },
        log: {
            quantityPre: 'Before the Configuration Change',
            quantity: 'After the Configuration Change'
        },
        userPermission: {
            userAccount: 'User Account',
            userName1: 'User Name',
            userName: 'Role Name',
            userStatu: 'Role Status',
            selUser: 'Select a Role',
            prompt: 'Tip: Please do not add the role of Events administrator here, if you need to add please grant the appropriate permissions in the Events.',
            addUserPrompt: 'Tip: If the added user has a role (whether it expires or not) can not do anything for this user, need to postpone it please return to the user role management page to take action on it.',
            delUserPrompt: 'The content you want to delete may not have permission to delete (e.g. System Admin) or you may no longer be able to delete the show manager here!',
            sureDel: 'Are you sure to delete this data and its related data?',
            inputUser: 'Please enter the role name',
            inputInstruction: 'Please enter the instructions',
            instruction: 'Description',
            selOneUser: 'Please select at least one role',
            privilegeExtension: 'Permission Extension',
            extension: 'Delay',
            extensionSuccess: 'Delayed Success',
            effectDate: 'Effective Date',
            overdueDate: 'Expiration Date',
            extensionDate: 'Extension Date',
            extensionErrTip: 'The extension date you set is less than the effective date and this data will not be deferred',
            sureExtension: 'Confirm the Extension',
            endBigStar: 'Start date cannot be greater than end date',
            noEffect: 'Not Effective',
            isOverdue: 'Expired',
            isExtension: 'Effective',
            soonOverdue: 'Coming Soon',
            arrival: 'The arrival date cannot be later than the departure date'
        }
    },
    // 车辆资源配置国际化
    vehicleConfig: {
        vehicleTypeConfiguration: 'Vehicle Type Configuration',
        vehicleRule: 'Vehicle Rules',
        cancellationRuleDesc: 'Cancellation Rule Description',
        cancellationRule: {
            title: 'Cancellation Rule',
            checkInDaysMin: 'Cancel the lower limit of the period between the reservation start time and the end time.',
            checkInDaysMax: 'Cancel the upper limit of the period between the reservation start time and the end time',
            fee: 'Fee Deduction Ratio（%）'
        },
        vehicleLock: {
            title: 'Vehicle Lock Setting',
            lockType: 'Lock Type',
            lockTime: 'Lock Time',
            selectLockTime: 'Select Lock Time'
        },
        vehicleTime: {
            title: 'Vehicle Use Time Settings',
            useVehStartTime: 'Vehicle Use Start Time',
            selectUseVehStartTime: 'Select vehicle use start time',
            useVehEndTime: 'Vehicle Use End Time',
            selectUseVehEndTime: 'Select vehicle use end time'
        },
        btn: {
            import: 'Import',
            importTemplate: 'Import Template',
            export: 'Export'
        },
        form: {
            title: {
                add: 'New Vehicle Type',
                edit: 'Edit Vehicle Type',
                view: 'View Vehicle Type'
            },
            placeholder: {
                inputVehName: 'Enter the vehicle type name',
                inputPassengersNum: 'Enter number of passengers',
                inputVehNameCN: 'Enter the vehicle type name(CN)',
                inputVehNameEN: 'Enter the vehicle type name(EN)',
                inputPickupPrice: 'Enter this airport/station price'
            },
            vehicleType: 'Vehicle Type',
            passengersNum: 'Number of Passengers',
            vehName: 'Vehicle Type Name',
            vehNameCN: 'Vehicle Type Name(CN)',
            vehNameEN: 'Vehicle Type Name(EN)',
            isPickup: 'Airport/Station Pick-up and Drop-off',
            pickupPrice: 'Airport/Station Price',
            isReleased: 'Is Released',
            versionNo: 'Version No.',
            vehCode: 'Vehicle Code',
            vehIntroduction: 'Vehicle Type Introduction',
            vehPic: 'Vehicle Type Picture',
            vehPicContent: {
                title: 'Only JPG and PNG files are supported. The size of a single file cannot exceed 10 MB.',
                content: 'Upload Vehicle Type Image'
            },
            vehPricelist: 'Common Duration and Fee',
            vehPriceTable: {
                duration: 'Duration(h)',
                price: 'Price'
            },
            vehSupPricelist: 'Supplier Contract Quotation',
            vehSupPriceTable: {
                supplier: 'Supplier',
                contractPrice: 'Contract Pice',
                overtimeFee: 'Overtime Fee',
                overKilometerFee: 'Over-Kilometer Fee'
            },
            vehQtylist: 'Allocation Configuration',
            vehQtyTable: {
                dateRange: 'Vehicle Use Date Range',
                date: 'Date',
                quantity: 'Amount Allocated',
                allowance: 'Vacancies'
            },
            historicalVersionQuery: 'Historical Version Query',
            historyVerTable: {
                lastUpdateUser: 'Last Update User',
                lastUpdateDate: 'Last Update Date',
                view: 'View'
            }
        },
        errorText: {
            required: 'Required',
            typeInteger: 'Type a Positive Integer.',
            maxNumber999: 'Maximum Number of Guests 999.',
            maxBigMin: 'The maximum number of customers must be greater than or equal to the minimum number of customers.',
            only1to9999999: 'The value must be an integer ranging from 1 to 9999999.',
            only1to24: 'The value must be an integer ranging from 1 to 24.',
            cannotSame: 'Two same records cannot be configured!',
            maxNumber1000: 'A maximum of 1000 characters are allowed.',
            bookedNo0cannotDelete: 'Cannot delete the booking because the booking quantity is not 0.',
            cannotLessThanReservedVolume: 'The allocated volume cannot be less than the reserved volume ',
            onlyJpgPng: 'Only JPG and PNG files are supported!',
            onlyByFileFormat: 'Only {0} files are supported!',
            lessMB: 'The size of a single file cannot exceed {0} MB.',
            notAllowed0: 'Files whose size is 0 are not allowed to be uploaded',
            limit: 'Upload up to {0} attachments',
            less10M: 'The size of a single file cannot exceed 10 MB.',
            time0to100: 'Start time. The value ranges from 0 to 100.',
            greaterThanLowerLimit: 'The value must be greater than the lower limit.',
            lessThanUpperLimit: 'The value must be less than the upper limit.',
            startTImeCannotGreaterEnd: 'The start time cannot be later than the end time',
            cannotLessNow: 'Cannot be earlier than the current time.',
            vehicleOnlyOnceTime: 'A vehicle type can have only one time segment',
            vehicleOnlyOnceLock: 'One lock can be set only once for a vehicle type.',
            bookedLockLessQueuingLock: 'The reservation lock time must be later than the queuing lock time for the same vehicle type, Please reset the time.'
        },
        messagebox: {
            confirmDelete: 'Are you sure you want to delete?',
            confirmReset: 'Are you sure you want to reset the rule description?',
            releasedSucess: 'Release Successfully',
            cancelReleasedSucess: 'Canceled Successfully',
            saveAndQuit: 'The vehicle type information has changed. Save the change and exit?',
            quitEdit: 'The vehicle type information has changed. Are you sure you want to cancel the editing?',
            atLeastOne: 'At least one valid item must be configured for the allocated volume',
            deleteCancelRule: 'Exercise caution when deleting a cancellation rule!',
            deleteVehicleLock: 'Exercise caution when deleting the vehicle lock!',
            deleteSuccess: 'Deleted Successfully.'
        }
    },
    // 财务管理
    financialManagement: {
        financialManagement: 'Financial Management', // 财务管理
        businessTravelFinance: 'Business Travel Finance', // 商旅财务
        BM: {
            budgetManagement: 'Budget Management', // 预算管理
            isEnable: 'Enable Budget Management', // 是否启用预算管理
            noEnable: 'Budget management is not enabled for this exhibition', // 该展会未启用预算管理
            groupNo: 'Group No.', // 团组编号
            applicantName: 'Applicant Name', // 申请人
            applicantDate: 'Application Date', // 申请日期
            totalBudget: 'Total Budget', // 预算总额
            hotelBudget: 'Hotel Budget', // 酒店预算
            hotelRoomCharge: 'Hotel Room Charge', // 酒店房费
            hotelNoShow: 'Hotel NoShow', // 酒店Noshow
            hotelRemaining: 'Hotel Remaining', // 酒店剩余
            vehicleBudget: 'Vehicle Budget', // 车辆预算
            vehicleExpense: 'Vehicle Expense', // 车辆费用
            vehicleNoShow: 'Vehicle NoShow', // 车辆Noshow
            vehicleRemaining: 'Vehicle Remaining', // 车辆剩余
            deptName: 'Expense Department', // 费用部门
            projectName: 'Expense Project', // 费用项目
            groupSource: 'Group Source', // 团组来源
            addBudget: 'Add Budget', // 新增预算
            editBudget: 'Edit Budget', // 编辑预算
            sumBudget: 'Total Resource Budget', // 资源预算总计
            modifyLogs: 'Modify Logs', // 修改日志
            w3Account: 'Modified By', // 修改人
            operateDate: 'Modification Date', // 修改日期
            oldDesc: 'Information Before Modification', // 修改前信息
            newDesc: 'Information After Modification' // 修改后信息
        },
        placeholder: {
            groupNo: 'Please enter group No', // 请输入团组编号
            groupNoAndSearch: 'Please enter group No and search', // 请输入团组编号并点击搜索
            hotelBudget: 'Please enter hotel budget', // 请输入酒店预算
            vehicleBudget: 'Please enter vehicle budget' // 请输入车辆预算
        },
        message: {
            saveSuccessed: 'Saved successfully', // 保存成功
            associated: 'The operation cannot be performed because an associated order already exists', // 已有关联订单，无法操作。
            configBudget: 'Please configure the budget', // 请配置预算
            hotelBudget: 'The hotel budget is less than the used budget {0}. Please reconfigure', // 酒店预算小于已使用预算{0}，请重新配置
            vehicleBudget: 'The vehicle budget is less than the used budget {0}. Please reconfigure', // 车辆预算小于已使用预算{0}，请重新配置
            sumBudgetReconfig: 'The sum of the hotel budget and vehicle budget has exceeded the total budget. Please reconfigure.' // 酒店预算与车辆预算之和已超出预算总额，请重新配置
        },
        confirmMsg: {
            deleteOperation: 'Are you sure you want to delete the selected data?', // 确认删除已选择的数据吗？
            cancelOperation: 'Are you sure you want to cancel the operation?' // 是否确认取消操作？
        },
        errorMsg: {
            hasAssociatedOrder: 'The operation cannot be performed because an associated order already exists.', // 已有关联订单，无法操作。
            hasBookedOrder: 'The date cannot be deleted because it contains orders that are successfully reserved.', // 该日期下已有预订成功订单，不能删除！
            plsAddTotalBudget: 'The budget is insufficient and the order cannot be submitted. Please add the total budget.', // 预算不足，无法提交订单，请追加总预算!
            plsAddBudget: 'Insufficient budget. Please adjust the group budget.',
            plsContactPM: 'Cannot submit the order due to insufficient budget. Please contact the project manager (reception manager) to increase the budget.', // 预算不足，无法提交订单，请联系项目经理（接待经理）追加预算!
            noInMRS: 'The group ID does not exist in the MRS system or is not approved. Check the group information please to MRS system.', // 该团组编号不在MRS系统存在或者未审批通过，请在MRS团组中核对团组信息。
            configBudget: 'Please configure the budget.', // 请配置预算。
            onlyNonnegativeNumber: 'The value must be a non-negative number ranging from 0 to 9999999.99.', // 只能输入非负数，最小0，最大9999999.99。
            overBudget: 'The total resource budget has exceeded the total budget. Please reconfigure.', // 资源预算总计已超出预算总额，请重新配置。
            groupConfigured: 'The budget has been configured for the group and cannot be added again.', // 该团组预算已配置，不可重复新增。
            hotelBudget: 'The hotel budget is less than the used budget. Please reset it.', // 酒店预算小于已使用预算，请重新配置。
            vehicleBudget: 'The vehicle budget is less than the used budget. Please reset it.', // 车辆预算小于已使用预算，请重新配置。
            noPermission: 'You do not have the permission to add the budget for this group.', // 无权限新增该团组预算。
            cannotDelete: 'Cannot delete the budget because it has associated orders or Noshow expenses.', // 该预算已有关联订单或Noshow费用支出，无法删除。
            groupNotExist: 'The group ID does not exist in the MRS system or is not approved. Check the group information please to MRS system.' // 该团组编号不在MRS系统存在或者未审批通过，请在MRS团组中核对团组信息。
        },
        FS: {
            financialStatements: 'Financial Statements', // 财务报表
            hotel: 'Hotel', // 酒店
            vehicle: 'Vehicle', // 车辆
            inventory: 'Inventory Management Table', // 库存管理表
            checkin: 'Hotel check-in curve', // 酒店实际入住曲线表
            sale: 'Hotel Sales Contribution Rate', // 酒店销售贡献比率图
            inventoryTable: {
                date: 'Date', // 日期
                hotelName: 'Hotel Name', // 酒店名称
                room: 'Room Type', // 房型
                groupName: 'Group Name', // 团组名称
                export: 'Export', // 导出
                hotel: 'Hotel', // 酒店
                roomStatistics: 'Room Type Statistics and Group Reservation', // 房型统计及团组预订
                roomContractPrice: ' Room contract price', // 房间合同价
                roomPrice: 'Room Price', // 房间售价
                roomTotalQty: 'Total nights by room type', // 各房型间夜数合计
                totalContractPrice: 'Cost price', // 成本价
                totalPrice: 'Income', // 收入
                totalAmount: 'Amount' // 利润
            }
        }
    },
    // 展会配置国际化
    exhiConfig: {
        plsExhiNameTip: 'Enter a site name.',
        delTip: 'Are you sure you want to perform this operation?',
        mainSite: 'Main site',
        breakoutRoom: 'Breakout Room',
        mapLonLat: 'Longitude / Latitude',
        baidu: 'BaiDu',
        google: 'Google',
        plsSiteName: 'Enter a site name',
        scrollLockSettings: 'Scroll lock settings',
        lockType: 'Lock Type',
        lockDate: 'Lock Date',
        effectiveDate: 'Effective Date',
        effectiveStatus: 'Effective Status',
        exhiShortName: 'Short for the Events',
        upload1920: 'Upload a resource home page banner1920*500px',
        upload760: 'Upload the Events home page banner760*410px',
        uploadLimitSize: 'Upload the KV<br/>{0}*{1}px',
        isHotLimit: 'The recommended limit has been reached and cannot continue',
        hostDept: 'Please select the host department',
        error: 'Operation Failed',
        success: 'Operation was Successful',
        exhiIsSelected: 'The Show has been Quoted.',
        allSee: 'No One\'s Visible',
        adminSee: 'Administrator Sitviable',
        noSee: 'Invisible',
        editExhi: 'Edit the Events',
        upload: 'Upload',
        config: 'The Configuration of the Events',
        reset: 'Clear',
        exhiName: 'Name of the Events',
        enterExhiName: 'Please enter the name of the Events',
        enterExhiDate: 'Please enter the Events time',
        pleaseComplete: 'Please complete',
        Mandatory: 'Mandatory',
        modifiedModification: 'Check whether the name list is modified. If yes, save the modification.',
        exhiDate: 'Time of the Events',
        exhiPlace: 'The Location of the Events',
        enterPlace: 'Please enter the location',
        isShow: 'Is it visible?',
        export: 'Export',
        isHot: 'Recommended Events',
        all: 'All',
        exhiBasicInfo: 'Basic information about the Events',
        exhiNameCN: 'Name of the Events (Chinese)',
        exhiNameEN: 'Name of the Events (US)',
        enterExhiNameEN: 'Please enter the English name of the Events',
        checkExhiNameEn: 'Do not enter Chinese characters',
        CIMSName: 'ID of CIMS Events',
        MRSName: 'ID of MRS Events',
        defaultCurrency: 'Default Currency Name',
        currencySymbol: 'Default Currency Symbol',
        countryName: 'Countries/Area',
        provinceName: 'Province/District',
        cityName: 'City',
        baiduLongitude: 'The latitude and longitude of Baidu map',
        Longitude: 'Longitude',
        Latitude: 'Latitude',
        googleLongitude: 'The latitude and longitude of Google map',
        timeZone: 'Time',
        enterTimeZone: 'Please Choose a Time Zone',
        exhiAdmin: 'The Manager of the Events',
        exhiAdminBus: 'Service side Administrator',
        deptCode: 'Host',
        introduction: 'Introduction to the Events',
        enterIntroduction: 'Please enter the Events introduction',
        enterContent: 'Please Enter Something',
        bigPhoto: 'Events Pictures',
        imgTip: 'Support for jpg, png and other format files, single files no more than 10MB',
        exhiType: 'Events Type',
        singleGroup: 'Single Group',
        multiGroup: 'Multi Group',
        selectExhi: 'Select the Events',
        enterLatitude: 'Enter latitude',
        enterLongitude: 'Enter longitude',
        LatitudeRange: '-90 ~ 90',
        LongitudeRange: '-180 ~ 180',
        dot10: 'You can only fine to 10 decimal places',
        rule: 'Hotel Rules',
        importingListRule: 'List Import Rules',
        enterRule: 'Please enter the hotel rules',
        max4000: '4000 characters maximum input',
        max150Tip: 'The value can contain a maximum of 150 letters and digits.',
        enterAdmin: 'Please select the show manager',
        max5: 'Choose up to 5 show managers',
        bizhong: 'Please select a currency',
        bizhongFuhao: 'Please enter the currency symbol',
        enterCountry: 'Please select a country',
        enterProvince: 'Please select a province or state',
        enterCity: 'Please choose a city',
        enterCityExhi: 'Please select a city or enter "TBD"',
        enterTime: 'Please choose a time zone',
        uploadIng: 'Please upload an image',
        limit1920: 'A single file must be a size 1920*500px',
        limitSize: 'No more than {0}MB per file',
        fail: 'Upload Failed',
        editSucess: 'Editing the success of the Events',
        addSucess: 'New Events Success',
        exhiDetail: 'Details of the Events',
        addExhi: 'New Events',
        roomMax: 'Book Room Ceiling',
        custMax: 'Customer Co-housing Cap',
        cancelMin: 'Cancellation sitoff sittin minimum limit of days staying',
        cancelMax: 'Cancellation spree maximum stay-in days range',
        fee: 'Fee Deduction Ratio（%）',
        enterRoomMax: 'Please enter the maximum room limit for reservation',
        roomLimit: 'Maximum Reservations 1-99',
        enterCustMax: 'Please enter the customer co-housing limit',
        custLimit: 'Customer Co-housing cap 1-4',
        ruleErr: 'Hotel Rules are Incorrect',
        ruleErr2: 'Hotel Rules are Incomplete',
        rangeLimit: 'Stay-in-day Range 0 - 100',
        dayuDown: 'Must be more than the lower limit number of days',
        noRepeat: 'You cannot add duplicate configuration information for the same interval',
        dayuUp: 'Must be less than the maximum number of days',
        feeLimit: 'Fee Deduction Ratio 0 - 100',
        deletSuccess: 'Removal Successful',
        companyFee: 'Company Pays',
        tripFee: 'Business Travel Payments',
        limit760: 'A single file must be 760 x 410px',
        imgLimitSize: 'A single file must be {0} x {1}px',
        mapLongLatitude: 'Map longitude and latitude',
        enterVenue: 'Please enter the Venue Name',
        enterVenu: 'Please enter the Venue Name',
        maxLength150: 'Enter up to 50 Chinese characters or 150 English letters and numbers',
        notRepeat: 'Please don\'t enter the same Venue Name'
    },
    // 火车票、飞机票、休闲资源
    trainTicket: {
        editS: 'Editing Success',
        addS: 'New Success',
        placeOfOrigin: 'Origin',
        destination: 'Destination',
        cheCi: 'Trips/Models',
        fare: 'Fare',
        placeOfOriginPY: 'Origin (Pinyin)',
        destinationPY: 'Destination (Pinyin)',
        tripDate: 'Travel Dates',
        ticketLJ: 'Train Ticket Resources Linked',
        tripIntro: 'Description of the Itinerary',
        planeCom: 'Airlines',
        zheKou: 'Discount',
        xieYiJia: 'Agreement Price',
        planeLJ: 'Ticket Source Link',
        planeInfo: 'Flight Description',
        type: 'Type',
        lersureName: 'Leisure Resource Name',
        lersureNameLJ: 'Leisure Resources Link',
        lersureImg: 'Leisure Resources Pictures',
        limit10: 'Support for jpg, png and other format files, single files no more than 10MB',
        trainZYPZ: 'Train ticket resource configuration',
        enterPlaceOfOrigin: 'Please enter the origin',
        enterDestination: 'Please enter your destination',
        enterCheCi: 'Please enter the number of cars/Models',
        planeZYPZ: 'configuration of Ticket Resources',
        leisureZYPZ: 'Leisure Resource Configuration',
        limitLength300: 'Up to 300 Bytes Input',
        notBeEqual: 'Destination and origin cannot be the same',
        notBeEqualPY: 'Destination (Pinyin) and Origin (Pinyin) cannot be the same',
        enter: 'Please enter',
        limitLength150: 'Up to 150 Bytes Input',
        limitDot2: 'Up to two decimal places',
        limitLength900: 'Maximum Input of 900 Bytes',
        limit4000: 'Maximum Input of 4000 Bytes',
        enterOriginDAXIE: 'Please enter the Origin Pinyin (Capital)',
        enterDestinationDAXIE: 'Please enter the destination pinyin (capital)',
        maxNum10: 'Only Enter a Range of 0 - 10',
        isDelete: 'Please confirm whether to delete?',
        tips: 'Tips',
        leastOne: 'Please select a piece of data',
        enterPlaneName: 'Please enter the airline name',
        addTrain: 'New Train Tickets',
        editTrain: 'Edit Train Tickets',
        lookTrain: 'View Train Ticket Details',
        addPlane: 'New Tickets',
        editPlane: 'Edit Your Ticket',
        lookPlane: 'View Ticket Details',
        addLeisure: 'New Leisure Resources',
        editLeisure: 'Editing Leisure Resources',
        lookLeisure: 'View leisure resourcedetails for details',
        limitWidth368: 'A single file must be 368 x 220px',
        dayuling: 'Cannot enter negative numbers',
        URL: 'Address that must start with https or http and conform to the url specification',
        isHot: 'Is it recommended?'
    },
    // 车辆预订配置详情国际化
    byCar: {
        placeholder: 'Please enter a place to find',
        appOffCar: 'Completed Request for Drop-off Car',
        appMeetCar: 'Completed Request for Drop-off Car'
    },
    // 个人中心
    personalCenter: {
        personalTitle: 'User Info', // done
        editPersonalInfo: 'Edit User Info', // done
        modifyPassword: 'Change Password', // 1
        name: 'Full Name', // 1
        phone: 'Mobile', // done
        email: 'Email', // 1
        landline: 'Landline', // 1
        nationality: 'Country', // done
        sex: 'Gender', // 1
        placeholder: {
            lastName: 'LastName(姓)', // 1
            fristName: 'FristName(名)', // 1
            phoneCode: 'City Code', // 1
            phone: 'Phone Number', // 1
            extensionNo: 'Extension', // 1
            tel: 'Please enter your phone number',
            area: 'Please choose the place of origin'
        },
        commonAddress: {
            edit: 'Edit Address',
            add: 'Add Address', // 1
            name: 'Full Name', // 1
            tel: 'Mobile', // done
            city: 'Address', // done
            detailAddress: ' ', // done
            zip: 'Zip Code', // done
            tip: {
                selectCountryAreaCode: 'Please select your phone area code',
                inputTel: 'Please enter the correct phone number',
                inputName: 'Please enter the name',
                inputPhone: 'Please enter your phone number',
                inputZip: 'Please enter the zip code'
            }
        }
    },
    // 公司预订酒店详情页面国际化
    detailHotel: {
        copySuccess: 'Replication Successful',
        prompt: 'Warm Tip: Check-in and departure earliest check-in time: after {0} the latest departure time: before {1}'
    },
    // 我的导入导出
    myImportExport: {
        title: 'My Import Export',
        dialogTitle: 'Import Export Information',
        tipInfo: 'Please view export import information in my import export',
        toImportExport: 'Enter My Import Export',
        serialNumber: 'No.',
        fileName: 'File Name',
        importTab: 'My Import',
        exportTab: 'My Export',
        importStatus: 'Import Status',
        exportStatus: 'Export Status',
        fileSize: 'File Size',
        operateQty: 'Number of Import Bars',
        exportQty: 'Number of Export Bars',
        totalTime: 'Total Time-consuming'
    },
    // 我的钱包
    myWalletI18n: {
        inNoshow: 'Including Noshow',
        myWallet: 'My Wallet',
        feeType: 'Fee Type',
        conAmount: 'Consumption Amount',
        used: 'used',
        unused: 'unused',
        contractPrice: 'Contract unit price',
        plsEnterContractPrice: 'Enter the contract unit price.',
        frontlinePersonTips: 'If additional budget is needed for the hotel and vehicle, please contact the project manager (reception manager).',
        hotelExpenditure: 'Hotel budget expenditure',
        vehicleExpenditure: 'Vehicle budget expenditure',
        totalExpenditure: 'Total budget expenditure',
        modifyBudget: 'Modify Budget',
        addTotalBudget: 'Additional total budget',
        totalRemaining: 'Total Remaining',
        expenseDetails: 'Expense Details'
    },
    // 订单列表
    orders: {
        phoneCheck: 'Enter a correct phone number!',
        gmdzzbyhbj: 'The list is being edited by {0}. Please process later!',
        selectModificationRecords: 'Select two modification records for comparison',
        comparisonOfModifiedRecords: 'Comparison of modified records',
        projectManager: 'Project Manager',
        importList: 'Import List',
        exportCustomers: 'Export Customers',
        plsEneterOrderNo: 'Please enter the order number',
        keyword: 'Keyword',
        plsEneterKeyword: 'Order No./Group No./Hotel name',
        recentOrdersTitle: 'Recent Orders',
        orderNo: 'Order No.',
        bookingTravelDate: 'Check-in/Departure Date',
        inputSchedDate: 'Please select the check-in and check-out date.',
        company: 'Company',
        creationDate: 'Booking Date',
        totalAmount: 'Total Amount',
        rooms: 'Room(s)',
        night: 'Night(s)',
        status: {
            submitted: 'Submitted',
            waitingConfirm: 'To be Confirmed',
            confirmed: 'Confirmed',
            cancelled: 'Cancelled',
            waitingPaid: 'Unpaid', // done
            review: 'Review',
            quotaRoomConfirmed: 'Quota room to be confirmed',
            newSubmission: 'New Submission'
        }
    },
    // 媒体模块
    media: {
        // 组织模块
        organization: {
            contactPerson: 'Contact person',
            creationTime: 'Creation Time'
        },
        // 申请模块
        application: {
            enterKeywords: 'Enter keywords: Application No./Name/Industry/Unit',
            waitApproval: 'To Be Approved',
            creator: 'Creator',
            batchApproval: 'Batch Approval',
            remark: 'Remarks'
        },
        person: {
            msg: {
                cancelAttendAcknowledge: 'Are you sure you want to cancel the meeting?',
                cancelAttendAcknowledgeBeforeEnd: 'Are you sure you want to cancel this guest’s participation?',
                cancelAttendAcknowledgeAfterEnd: 'Are you sure you want to cancel your participation? After cancellation, the corresponding seat number will be invalid and cannot be re-registered. If you still need it, please contact the administrator. Thank you!'
            }
        }
    },
    switchConfig: {
        resourceNodeSwitch: 'Resource Node Switch',
        personErrorTip: 'The personnel has orders. Cannot be closed.'
    },
    registManage: {
        qrcode: 'QR code',
        mobileQrcode: 'Mobile qrcode',
        scanQrcode: 'Scan QR code for realname collect',
        registManage: 'Registration',
        registManageConfig: 'Registration Management',
        resourceConfig: 'Registration resource',
        registList: 'Registration List',
        electronicTicket: 'Electronic ticket',
        agendaManage: 'Agenda Management',
        blacklistManage: 'Blacklist Management',
        agenda: 'Agenda',
        guest: 'guest',
        staff: 'staff',
        uploadTip: 'Note: Try to upload images with clear front faces in formats that support 5M JPG, PNG, JPEG, and BMP.',
        uploadNoCheckTip: 'Note: support 5M JPG, PNG, JPEG, and BMP.',
        batchPass: 'Batch consent',
        batchReject: 'Batch Rejection',
        agendaConfig: 'Agenda configuration',
        speakerConfig: 'Speaker configuration',
        activeDate: 'Active date',
        agendaSubject: 'Subject under discussion',
        post: 'Post',
        speaker: 'Speaker',
        speakerPost: 'Speaker post',
        country: 'Country',
        timeInterval: 'Time interval',
        addTimeInterval: 'Add time interval',
        uploadPic: 'Upload photo',
        groupConfig: 'Group config',
        groupContacter: 'Group contacter',
        staffPermConfig: 'Staff permission config',
        staffPerm: 'Staff permission',
        staffPermCN: 'Staff permission(CN)',
        staffPermEN: 'Staff permission(EN)',
        permDesc: 'Permission description',
        isNeedReview: 'Need Review',
        reviewApprover: 'Review Approver',
        seatConfig: 'Seat config',
        regionalConfig: 'Regional config',
        regional: 'Regional',
        registEndTime: 'Registration Deadline',
        registeredScale: 'Registered scale',
        ticketClassifyConfig: 'Ticket classify config',
        audience: 'audience',
        audienceNameCN: 'Audience Name(CN)',
        audienceNameEN: 'Audience Name(EN)',
        otherConfig: 'Other config',
        smsConfig: 'SMS config',
        isCertificateRequired: 'Certificate required',
        isCertificateCollect: 'Certificate collect',
        freezeTime: 'cancel freeze time',
        ticketDetailDisplay: 'Ticket detail display',
        headerImgRequired: 'Header img required',
        headerImgType: 'Image type',
        headerImgDesc: 'Image description',
        faceOnly1: 'Face (only 1)',
        otherAllow2: 'Other (allow 2)',
        staffPermFreezeTime: 'Staff permission setting freeze time',
        permAppraved: 'Staff permission approve',
        approveConfig: 'Approve config',
        approveStatus: 'Approve status',
        seatNo: 'Seat No.',
        seatNoRegion: 'Seat/Regional No.',
        isSupportTransfer: 'Support transfer',
        transApprover: 'Transfer approver',
        groupName: 'Group name',
        sequence: 'Order',
        scale: 'scale',
        groupNameCN: 'Group name(CN)',
        groupNameEN: 'Group name(EN)',
        confirmSend: 'Confirm send',
        sendEmail: 'Send email',
        savePicture: 'Save picture',
        scanAndDraw: 'Scan QR code for collection',
        receiverSeatNo: 'Receiver-Seat No.',
        receiverCorporateName: 'Receiver-CorporateName',
        receiverCardNo: 'Receiver-Card No.',
        receiverCardType: 'Receiver-Card type',
        cardType: 'Card type',
        receiverPhoneNo: 'Receiver-Phone',
        receiver: 'Receiver',
        transferor: 'transferor',
        transferTime: 'Transfer time',
        staffNo: 'Staff No.',
        staffName: 'Staff Name',
        staffName1: 'Staff Name:',
        staffCardNo: 'staff card No.',
        cardNo: 'Employee ID Card Number',
        cardNo1: 'Employee ID Card Number:',
        chipNo: 'Chip Number:',
        countryRegion: 'Nationality',
        IDNumber: 'ID number',
        companyName: 'Company name',
        guestRegistManage: 'Guest registration management',
        employeeRegistManage: 'Employee registration management',
        transferApprovalManage: 'Transfer Approval Management',
        privacyConfig: 'Privacy Configuration',
        department: 'Department',
        selectSeatNo: 'Seat No./Regional',
        cancelSuccess: 'Canceled successfully',
        sureTransPass: 'Are you agree?',
        transSuccess: 'successfully',
        transFailed: 'failed',
        sureTransReject: 'Are you reject?',
        rejectSuccess: 'successfully',
        rejectFailed: 'failed',
        headerPicLimit5: 'The size of a photo cannot exceed 5 MB.',
        timeoverlap: 'Time overlap error',
        startEndTimeErr: 'Start time less than end time',
        endStartTimeErr: 'End time greater than start time',
        batchSave: 'Batch save',
        require: 'Please perfect require item!',
        sendEmailSuccess: 'Mail sent successfully!',
        sendEmailFailed: 'Email sending failed!',
        tipOneRow: 'Please select at least 1 record！',
        fill4Number: 'Please enter 4 digits',
        fillTime: 'Fill time',
        isRegisted: 'Is registered',
        grantPerms: 'Assigned permissions',
        isAllocated: 'is allocated',
        isDivided: 'is Divided',
        keyword: 'keyword',
        invalid: 'invalid',
        audienceVote: 'Audience vote',
        ticketAgent: 'Ticket agent',
        attendStatus: 'Partic status',
        sendMeetingInfo: 'Send meeting info',
        checkInStatus: 'Check in status',
        entryStatus: 'Entry Status',
        submitter: 'Submitter',
        submitTime: 'Submit Time',
        staffPermSetting: 'Staff permission settings',
        seatSearchholder: 'Please enter keywords(seat No./interface person)',
        guestSearchholder: 'Please enter keywords(name/seat/regional/company)',
        staffSearchholder: 'Please enter keywords(name/account)',
        staffPermSettingSucc: 'Staff permissions are set successfully',
        sendAttendMsgSucc: 'Join message sent successfully',
        approved: 'approved',
        staffNo1: 'employee ID',
        staffInfo: 'employee information',
        currentHandler: 'Current handler',
        processInfo: 'Process information',
        staffRegistApprove: 'Employee registration and approval electronic flow',
        seatNoinformation: 'Seat No.',
        guestRegistInfo: 'Guest registration',
        staffRegistInfo: 'Employee registration',
        approveDetail: 'Approval details',
        isnotify: 'is notified get married',
        nosign: 'no sign',
        signed: 'signed',
        noentry: 'no entry',
        entryed: 'entryed',
        checkIn: 'Check in',
        checkInSuccess: 'Sign in successfully',
        placeholderfill: 'Please fill...',
        placeholderselect: 'Please select...',
        approver: 'approver',
        transConfigTitle: 'Transfer Approval Configuration',
        guestConfigTitle: 'Guests related configuration',
        staffConfigTitle: 'Staff related configuration',
        entryTypeCfg: 'Entry type configuration',
        addImage: 'add pictures',
        isReject: 'Whether to reject',
        isConfirmApprove: 'Do you confirm batch consent?',
        isRejectApprove: 'Are you sure you want to confirm batch rejection?',
        isConfirmPermissionApprove: 'The employees you have selected will be granted the currently chosen permissions. Are you sure you want to approve this? ',
        setPermConfirmTips: 'The employees you have selected will be granted the currently chosen permissions. Are you sure? ',
        exceedingApprovalDeadline: 'Account {0} has exceeded the approval deadline! ',
        sendAttendMsg: 'Send attend message',
        msgContent: 'message content',
        sendType: 'Sending mode',
        sendTo: 'Send to',
        sendTime: 'Scheduled sending time',
        sender: 'Sender',
        sendingTime: 'Sending time',
        sendingStatus: 'Sending status',
        sendingStatus0: 'Not sent',
        sendingStatus1: 'Sent successfully',
        sendingStatus2: 'Sending failed',
        delSeatConfirm: 'Whether to confirm the invalid seat number?',
        recoverSeatConfirm: 'Whether to confirm the recover seat number?',
        delRegistedSeatConfirm: 'The selected items contain registered or invalidated seat numbers and cannot be invalidated!',
        delRegistedRegionConfirm: 'Information has been entered in this area of ​​the current exhibition and cannot be deleted!',
        delRegistedPermConfirm: 'This authority has been entered into employee information for the current exhibition and cannot be deleted!',
        empPermDead: 'Staff permission settings are frozen',
        empPermApproving: '{0} Employee permissions are subject to approval and cannot be set repeatedly!',
        seatregionalsearch: 'Seat number/area search',
        seatsearch: 'Seat number search',
        staffAccount: 'Staff account',
        companyDept: 'Company-position',
        phoneRequired: 'Mobile number cannot be empty',
        setDeadline: 'Set dead line',
        systemDeadline: 'System freezetime',
        deadlinetips: 'Note: Only the administrator can operate after the freezing time',
        certificateNumber: 'ID No.',
        neetFaceReco: 'Requires face recognition',
        privacyPolicyConfig: 'Privacy policy configuration',
        showPrivacyPolicy: 'Show privacy policy',
        privacyPolicyUrl: 'Privacy policy url',
        errTipPrivacyPolicyUrl: 'Please enter privacy policy link',
        recover: 'Recover',
        groupQrcode: 'Group registration QR code',
        transCard: 'Transfer work permit',
        idCardErr: 'Please enter a valid ID number!',
        noHandleWidthVoid: 'This operation cannot be performed when the status is Canceled!',
        recoverWidthVoid: 'Only when the status is invalidated, it can be restored!',
        recoverSuccess: 'Recovery successful!',
        recoverFailed: 'Recovery failed!',
        phoneErrTip: 'Mobile phone number length is 11 digits',
        noPermOnRejectCancel: 'This operation cannot be performed when rejecting or canceling the participation status!',
        sameSeatCannotRecover: 'When there are the same seat numbers, restoration cannot be performed!',
        batchDownloadImg: 'Download pictures batch',
        transSuccess1: 'Transfer successful!',
        transFailed1: 'Transfer failed!',
        deleteObsoleteDelete: 'Only invalid data can be deleted. Please select again.',
        deleteConfirm: 'Are you sure you want to delete the seat number?',
        restrictedAge: 'Restricted age of registration',
        ageLimits: 'Age Limits',
        ageTips: 'Age Tip Content',
        policeValidate: 'Public security verification',
        guestExportTips: 'The exported file contains privacy information. Are you sure you want to export the file? If you need to export the file, encrypt the file before transmission.',
        statistic: 'statistic',
        seatsNumber: 'Number of seats',
        registeredNumber: 'Number of registered',
        admissionsNumber: 'Number of admissions',
        blacklistConfig: 'Blacklist Config',
        blacklistRegister: 'Blacklist Register',
        licensePlateNumber: 'License plate number',
        licensePlateNumberErrorTip: 'Please enter the correct license plate number!',
        delBlacklistConfigConfirm: 'Are you sure you want to delete the selected blacklist entries?',
        remarkErrorTip: 'Maximum input: 1000 Chinese characters or 3000 English letters and numbers.',
        blacklistConfigSaveSuccess: 'Configuration successful',
        blacklistConfigSaveFailed: 'Configuration failed',
        blacklistConfigUpdateSuccess: 'Configuration update successful',
        blacklistConfigUpdateFailed: 'Failed to update configuration',
        blacklistRegisterAccount: 'Register Account',
        blacklistRegisterDate: 'Register Date',
        employeePermissionDescription: 'Employee Permission Description:',
        permissions: 'Permissions',
        isHuaweiEmployee: 'Huawei Employee',
        chipNumber: 'Card Number/ID Number',
        employeeGroup: 'Employee Group',
        scaleNumber: 'Scale Number',
        approvedNumber: 'Number of Approvals Granted',
        acheckInNumber: 'Number of check-ins',
        enteredNum: 'Number of Entries',
        importDialogTitle: 'Import Information View',
        importDescLine: 'Line {0}',
        isExhiAdminVisible: 'Visible only to exhibition administrators',
        empSmsConfig: 'Employee SMS Configuration',
        isRegisterSms: 'Automatically send a registration success SMS message after the approval is passed.',
        registerSmsContent: 'SMS message content',
        isCertificateSms: 'Automatically trigger certificate collection SMS messages',
        certificateSmsDate: 'Set the sending time',
        certificateSmsContent: 'SMS message content',
        empPermissionDeadline: 'Employee permission expiration date',
        community: 'Comm.',
        reviewStatus: 'Review permission status',
        approvalLog: 'Approval Log',
        approvalNode: 'Approval Status',
        approvalTime: 'Approval Time',
        approvalOpinion: 'Approval Opinion'
    }
}
